export const AVAILABLE_CONTRACT_ITEMS = [
  {
    contract_line: "10",
    tender_line: "10",
    description: "SURFACE DRESSING,SITE CLEARANCE/CLVRT 176050300066",
    uom: "square meter",
    rate: "9.46",
  },
  {
    contract_line: "20",
    tender_line: "20",
    description: "EXCAVATION,F/FNDTN,GRND LVL UPTO 1.5M 520903300026",
    uom: "cubic meter",
    rate: "150.53",
  },
  {
    contract_line: "30",
    tender_line: "30",
    description: "EXCAVATION,F/FNDTN,GRND LVL UPTO 3M 520604300022",
    uom: "cubic meter",
    rate: "263.22",
  },
  {
    contract_line: "40",
    tender_line: "40",
    description: "EXCAVATION,F/FNDTN,BTWN 3-4.5M 520903300024",
    uom: "cubic meter",
    rate: "376.77",
  },
  {
    contract_line: "50",
    tender_line: "50",
    description: "EXCAVATION,F/FNDTN,HR,GRND,UPTO 1.5M 520903300009",
    uom: "cubic meter",
    rate: "598.70",
  },
  {
    contract_line: "60",
    tender_line: "60",
    description: "EXCAVATION,F/FNDTN,HR,GRND,1.5-3M 520903300008",
    uom: "cubic meter",
    rate: "796.55",
  },
  {
    contract_line: "70",
    tender_line: "70",
    description: "EXCAVATION,F/FNDTN,HR,BTWN 3-4.5M 520903300023",
    uom: "cubic meter",
    rate: "1077.83",
  },
  {
    contract_line: "80",
    tender_line: "80",
    description: "SAND FILLING - LAYERS 150MM 510904400001",
    uom: "cubic meter",
    rate: "843.00",
  },
  {
    contract_line: "90",
    tender_line: "90",
    description: "SUPPLY&FILLING,CRSHD STN SND FLNG,150MM 520450300003",
    uom: "cubic meter",
    rate: "1321.27",
  },
  {
    contract_line: "100",
    tender_line: "100",
    description: "MURRUM FILLING LAYERS-150MM 510904400002",
    uom: "cubic meter",
    rate: "599.56",
  },
  {
    contract_line: "110",
    tender_line: "110",
    description: "SUPPLY&FILLING,IMPORTED EARTH,200MM 520950300019",
    uom: "cubic meter",
    rate: "388.81",
  },
  {
    contract_line: "120",
    tender_line: "120",
    description: "PCC 1:4:8 510201400001",
    uom: "cubic meter",
    rate: "3907.89",
  },
  {
    contract_line: "130",
    tender_line: "130",
    description: "PCC 1:3:6 510201400002",
    uom: "cubic meter",
    rate: "4279.49",
  },
  {
    contract_line: "140",
    tender_line: "140",
    description: "PCC 1:2:4 510201400003",
    uom: "cubic meter",
    rate: "4761.21",
  },
  {
    contract_line: "150",
    tender_line: "150",
    description: "PCC 1:2:4 FOR DPC-50MM 510201400004",
    uom: "square meter",
    rate: "259.78",
  },
  {
    contract_line: "160",
    tender_line: "160",
    description: "PROVIDING&LYNG,PCC 1:2:4,F/COPING C/WALL 520201300006",
    uom: "cubic meter",
    rate: "4908.30",
  },
  {
    contract_line: "170",
    tender_line: "170",
    description: "SPLY AND LAY OF RCC1:1.5:3,SUB-STR 510202300049",
    uom: "cubic meter",
    rate: "6205.48",
  },
  {
    contract_line: "180",
    tender_line: "180",
    description: "PROVIDING,MXNG&PLCNG,RCC,1:1.5:3 520202300013",
    uom: "cubic meter",
    rate: "7408.90",
  },
  {
    contract_line: "190",
    tender_line: "190",
    description: "PROVIDING,MXNG&PLCNG,RCC,1:1.5:3,RF SLB 520202300134",
    uom: "cubic meter",
    rate: "7750.40",
  },
  {
    contract_line: "200",
    tender_line: "200",
    description: "PROVIDING,MXNG&PLCNG,RCC,1:1.5:3,F/CLVRT 520202300011",
    uom: "cubic meter",
    rate: "7087.19",
  },
  {
    contract_line: "210",
    tender_line: "210",
    description: "PROVIDING,MXNG&PLCNG,RCC,1:1.5:3,UG TNK 520202300010",
    uom: "cubic meter",
    rate: "6028.28",
  },
  {
    contract_line: "220",
    tender_line: "220",
    description: "SUP & LAY - PCCRATIO:1:1.5:3,20MM,MIXING 510201300198",
    uom: "cubic meter",
    rate: "5713.45",
  },
  {
    contract_line: "230",
    tender_line: "230",
    description: "PROVIDING,MXNG&PLCNG,RCC,1:1.5:3,TPSLB 520201300043",
    uom: "cubic meter",
    rate: "6134.95",
  },
  {
    contract_line: "240",
    tender_line: "240",
    description: "SUP & LAY - PCCRATIO:1:1.5:3,F/GROUTING 510201300199",
    uom: "cubic meter",
    rate: "6161.61",
  },
  {
    contract_line: "250",
    tender_line: "250",
    description: "PROVIDING&LAYING,RMC,M-30C/WL/SBLDG/CNPY 520250300047",
    uom: "cubic meter",
    rate: "6651.07",
  },
  {
    contract_line: "260",
    tender_line: "260",
    description: "PROVIDING&LAYING,RMC,M25 520250300018",
    uom: "cubic meter",
    rate: "6454.08",
  },
  {
    contract_line: "270",
    tender_line: "270",
    description: "UNDER REAMED PILE RATIO:1:1.5:3,DIA:350M 520202300156",
    uom: "meter",
    rate: "1698.89",
  },
  {
    contract_line: "280",
    tender_line: "280",
    description: "SUPPLY,FBRCTN,HSTNG&PLCNG,HYSD RNFRMTBAR 520601300003",
    uom: "Metric ton",
    rate: "52131.15",
  },
  {
    contract_line: "290",
    tender_line: "290",
    description: "PROVIDING&CNSTRCTNG,BRICK MASONRY WORK 520301300024",
    uom: "cubic meter",
    rate: "3984.45",
  },
  {
    contract_line: "300",
    tender_line: "300",
    description: "PROVIDING&CNSTRCTNG,BRICK MASONRY WORK 7 510301400001",
    uom: "cubic meter",
    rate: "4833.46",
  },
  {
    contract_line: "310",
    tender_line: "310",
    description: "PROVIDING&CNSTRCTNG,BRICK MASONRY,CM1:5 520301300013",
    uom: "cubic meter",
    rate: "4479.06",
  },
  {
    contract_line: "320",
    tender_line: "320",
    description: "PARTITION 115 MM-BRICK MASONRY 510301400007",
    uom: "cubic meter",
    rate: "6630.42",
  },
  {
    contract_line: "330",
    tender_line: "330",
    description: "PROVIDING&CNSTRCTNG,FLY ASH BRICK MASNRY 520301300011",
    uom: "cubic meter",
    rate: "5925.06",
  },
  {
    contract_line: "340",
    tender_line: "340",
    description: "PROVIDING,CNCRT HLW BLK,200MM 520250300015",
    uom: "cubic meter",
    rate: "6380.96",
  },
  {
    contract_line: "350",
    tender_line: "350",
    description: "PROVIDING&CNSTRCTNG,RANDOM RUBBLE MASNRY 520405300002",
    uom: "cubic meter",
    rate: "3820.15",
  },
  {
    contract_line: "360",
    tender_line: "360",
    description: "PROVIDING&CNSTRCTNG,RR MASNRY,SUB&SPRSTR 520405300001",
    uom: "cubic meter",
    rate: "4116.06",
  },
  {
    contract_line: "370",
    tender_line: "370",
    description: "RUBBLE SOLLING 230 MM THK 510407400001",
    uom: "square meter",
    rate: "404.29",
  },
  {
    contract_line: "380",
    tender_line: "380",
    description: "RUBBLE SOLLING 150 MM THK 510407400002",
    uom: "square meter",
    rate: "353.54",
  },
  {
    contract_line: "390",
    tender_line: "390",
    description: "PROVIDING&LAYING,BRICK ON EDGE,PATHWAYS 520301300010",
    uom: "square meter",
    rate: "627.95",
  },
  {
    contract_line: "400",
    tender_line: "400",
    description: "BRICK PITCHING 510301400008",
    uom: "square meter",
    rate: "420.64",
  },
  {
    contract_line: "410",
    tender_line: "410",
    description: "FLUSH POINTING 510403400001",
    uom: "square meter",
    rate: "148.81",
  },
  {
    contract_line: "420",
    tender_line: "420",
    description: "RAISED POINTING 510350400001",
    uom: "square meter",
    rate: "273.54",
  },
  {
    contract_line: "430",
    tender_line: "430",
    description: "PROVIDING&APPLYING,SMTH CMNT PLASTER,CLN 520202300187",
    uom: "square meter",
    rate: "129.89",
  },
  {
    contract_line: "440",
    tender_line: "440",
    description: "PROVIDING&APPLYING,SMTH CMNT PLSTR,6MM 520302300013",
    uom: "square meter",
    rate: "125.59",
  },
  {
    contract_line: "450",
    tender_line: "450",
    description: "PROVIDING&LAYING,SMTHPLSTRNG,12,1:4CM 520202300189",
    uom: "square meter",
    rate: "157.42",
  },
  {
    contract_line: "460",
    tender_line: "460",
    description: "PROVIDING&LAYING,CEMENT PLASTERING,20MM 520202300188",
    uom: "square meter",
    rate: "219.35",
  },
  {
    contract_line: "470",
    tender_line: "470",
    description: "PROVIDING,FBRCTNG&INSTLNG,PIPES ,4KG/CM2 176050300065",
    uom: "meter",
    rate: "390.53",
  },
  {
    contract_line: "480",
    tender_line: "480",
    description: "SUPPLY&FIXING,MSPIPE RAIL,40MM,MDM 280104300079",
    uom: "Metric ton",
    rate: "92901.60",
  },
  {
    contract_line: "490",
    tender_line: "490",
    description: "SUPPLY&FIXING,CHN LNK FNC,GI,10SWG 176050300063",
    uom: "square meter",
    rate: "375.91",
  },
  {
    contract_line: "500",
    tender_line: "500",
    description: "PRECASTCONCRETEPOLES- FENCING 519050400003",
    uom: "Each",
    rate: "2432.65",
  },
  {
    contract_line: "510",
    tender_line: "510",
    description: "PROVIDING&FIXING,BRBD WR FNCNG 529050300008",
    uom: "meter",
    rate: "123.87",
  },
  {
    contract_line: "520",
    tender_line: "520",
    description: "SUPPLYING,LAYING,JNG&ALGNG,PIPE S,1000MM 280104300080",
    uom: "meter",
    rate: "6731.93",
  },
  {
    contract_line: "530",
    tender_line: "530",
    description: "SUPPLYING,LYNG,JNG&ALGNG,PIPES, 900MM,NP3 280104300051",
    uom: "meter",
    rate: "4481.64",
  },
  {
    contract_line: "540",
    tender_line: "540",
    description: "SUPPLYING,LYNG,JNG&ALGNG,PIPES, 600MM,NP3 280104300050",
    uom: "meter",
    rate: "1994.80",
  },
  {
    contract_line: "550",
    tender_line: "550",
    description: "SUPPLYING,LYNG,JNG&ALGNG,PIPES, 450MM,NP3 280104300049",
    uom: "meter",
    rate: "1396.10",
  },
  {
    contract_line: "560",
    tender_line: "560",
    description: "SUPPLYING,LYNG,JNG&ALGNG,PIPES, 300MM,NP3 280103300014",
    uom: "meter",
    rate: "654.61",
  },
  {
    contract_line: "570",
    tender_line: "570",
    description: "SUPPLYING,LYNG,JNG&ALGNG,PIPES, 250MM,NP3 280103300015",
    uom: "meter",
    rate: "499.78",
  },
  {
    contract_line: "580",
    tender_line: "580",
    description: "SPLY AND LAY OF PIPEHUME,200MM,NP3,FIX 511202300444",
    uom: "meter",
    rate: "461.07",
  },
  {
    contract_line: "590",
    tender_line: "590",
    description: "SPLY AND LAYG OF PIPE HUME,150MM,NP3 270102300793",
    uom: "Running Meter",
    rate: "385.37",
  },
  {
    contract_line: "600",
    tender_line: "600",
    description: "PROVIDING,ANTITERMIT TREATMENT 330150300008",
    uom: "square meter",
    rate: "189.24",
  },
  {
    contract_line: "610",
    tender_line: "610",
    description: "PROVIDING&LAYING,CRMC TL FLRNG,600X600MM 521014300026",
    uom: "square meter",
    rate: "627.09",
  },
  {
    contract_line: "620",
    tender_line: "620",
    description: "PROVIDING&LAYING,CRMC TL FLRNG,450X450MM 521014300053",
    uom: "square meter",
    rate: "548.81",
  },
  {
    contract_line: "630",
    tender_line: "630",
    description: "PROVIDING&LAYING,CRMC TL FLRNG,300X300MM 521014300052",
    uom: "square meter",
    rate: "529.02",
  },
  {
    contract_line: "640",
    tender_line: "640",
    description: "VITRIFIEDTILE 800MM X 800MM 511014400001",
    uom: "square meter",
    rate: "1108.80",
  },
  {
    contract_line: "650",
    tender_line: "650",
    description: "PROVIDING&LAYING,VTRFD TILEFLR,600X600MM 521014300045",
    uom: "square meter",
    rate: "890.31",
  },
  {
    contract_line: "660",
    tender_line: "660",
    description: "PROVIDING&FIXING,MNGLR TILE,230X150X12MM 521014300041",
    uom: "square meter",
    rate: "2022.33",
  },
  {
    contract_line: "670",
    tender_line: "670",
    description: "GRANITE TILE FLOORING 529050400001",
    uom: "square meter",
    rate: "1012.46",
  },
  {
    contract_line: "680",
    tender_line: "680",
    description: "PROVIDING,MXNG&LYNG,IPS FLRNG,50MM,STN 521015300003",
    uom: "square meter",
    rate: "326.88",
  },
  {
    contract_line: "690",
    tender_line: "690",
    description: "PROVIDING&FXNG,GRANITE SKIRTING,10X100MM 521007300004",
    uom: "square meter",
    rate: "1100.49",
  },
  {
    contract_line: "700",
    tender_line: "700",
    description: "PROVIDING&FXNG,CRMC TL DDO,TLT,300X200MM 521014300051",
    uom: "square meter",
    rate: "562.57",
  },
  {
    contract_line: "710",
    tender_line: "710",
    description: "PROVIDING&FXNG,CRMC TL DDO,TLT,300X400MM 521014300050",
    uom: "square meter",
    rate: "611.60",
  },
  {
    contract_line: "720",
    tender_line: "720",
    description: "PROVIDING&FXNG,CRMC TL DDO,TLT,300X600MM 521014300049",
    uom: "square meter",
    rate: "749.23",
  },
  {
    contract_line: "730",
    tender_line: "730",
    description: "GRANITE SLAB 16 MM BLACK 511050400004",
    uom: "square meter",
    rate: "3036.51",
  },
  {
    contract_line: "740",
    tender_line: "740",
    description: "HP LOGO FIXING 522501400001",
    uom: "Each",
    rate: "459.35",
  },
  {
    contract_line: "750",
    tender_line: "750",
    description: "PROVIDING&LAYING,KOTA STN FLRNG,600X600MM 521014300058",
    uom: "square meter",
    rate: "1078.69",
  },
  {
    contract_line: "760",
    tender_line: "760",
    description: "KOTA STONE SKIRTING 511002400003",
    uom: "square meter",
    rate: "1146.65",
  },
  {
    contract_line: "770",
    tender_line: "770",
    description: "PROVIDING&FIXING,KOTA STONE STEPS,18MM 520450300008",
    uom: "square meter",
    rate: "1261.91",
  },
  {
    contract_line: "780",
    tender_line: "780",
    description: "GRANITE SILL SLAB FOR WINDOWS 511007400003",
    uom: "square meter",
    rate: "2237.38",
  },
  {
    contract_line: "790",
    tender_line: "790",
    description: "SUPPLY&FIXING,CONCRETE TILE-WLKWY 520903300599",
    uom: "square meter",
    rate: "655.47",
  },
  {
    contract_line: "800",
    tender_line: "800",
    description: "BRICKBAT TERRACE WATER PROOF. 510703400001",
    uom: "square meter",
    rate: "586.66",
  },
  {
    contract_line: "810",
    tender_line: "810",
    description: "CHAJJA WATER PROOFING 520750400001",
    uom: "square meter",
    rate: "351.82",
  },
  {
    contract_line: "820",
    tender_line: "820",
    description: "PROVIDING&APPLYING,WHITE WASH,3COATS 330250300005",
    uom: "square meter",
    rate: "14.62",
  },
  {
    contract_line: "830",
    tender_line: "830",
    description: "PROVIDING&APPLYING,OIL BND DISTEMPR,2CT 330150300007",
    uom: "square meter",
    rate: "83.44",
  },
  {
    contract_line: "840",
    tender_line: "840",
    description: "PROVIDING&APPLYING,ACRYLCMLSN PNT,INT 330150300006",
    uom: "square meter",
    rate: "169.46",
  },
  {
    contract_line: "850",
    tender_line: "850",
    description: "PROVIDING&APPLYING,ACRYLCMLSN PNT,EXT 330150300005",
    uom: "square meter",
    rate: "179.78",
  },
  {
    contract_line: "860",
    tender_line: "860",
    description: "PROVIDING&APPLYING,PLASTIC EMULSN PAINT 330150300004",
    uom: "square meter",
    rate: "121.29",
  },
  {
    contract_line: "870",
    tender_line: "870",
    description: "PROVIDING&APPLYING,WTRPRF CEMENT PAINT 330150300003",
    uom: "square meter",
    rate: "63.65",
  },
  {
    contract_line: "880",
    tender_line: "880",
    description: "PROVIDING&APPLYING,SYN ENML PAINT OVRWL 330150300002",
    uom: "square meter",
    rate: "80.00",
  },
  {
    contract_line: "890",
    tender_line: "890",
    description: "PROVIDING&APPLYING,SYN ENML PANT OVRWL 330150300001",
    uom: "square meter",
    rate: "117.85",
  },
  {
    contract_line: "900",
    tender_line: "900",
    description: "PROVIDING&APPLYING,POP PUNNING,WL&CLNG 521009300002",
    uom: "square meter",
    rate: "105.80",
  },
  {
    contract_line: "910",
    tender_line: "910",
    description: "PROVIDING&FIXING,POP-MLDNG,3X3IN 521009300001",
    uom: "square meter",
    rate: "250.32",
  },
  {
    contract_line: "920",
    tender_line: "920",
    description: "SUPPLY,INSTLTN&FXNG,PRFBRCTD MS GRILL 520601300001",
    uom: "kilogram",
    rate: "95.48",
  },
  {
    contract_line: "930",
    tender_line: "930",
    description: "PROVIDING&FIXING,AL GLZD DR,12MM GLS 521050300120",
    uom: "square meter",
    rate: "4616.69",
  },
  {
    contract_line: "940",
    tender_line: "940",
    description: "PROVIDING&FXNG,AL GLZD DR,12MM TGHND GLS 521050300119",
    uom: "square meter",
    rate: "5090.66",
  },
  {
    contract_line: "950",
    tender_line: "950",
    description: "PROVIDING & FIXING,AL GLAZED DR,12MM GLS 511002400001",
    uom: "square meter",
    rate: "4584.87",
  },
  {
    contract_line: "960",
    tender_line: "960",
    description: "PROVIDING&FIXING,HYDRLC FLR SPRG,61-80KG 521014300059",
    uom: "Each",
    rate: "2605.55",
  },
  {
    contract_line: "970",
    tender_line: "970",
    description: "PROVIDING&FIXING,AL PNLD DR,PWDR CTD 521050300117",
    uom: "square meter",
    rate: "4366.38",
  },
  {
    contract_line: "980",
    tender_line: "980",
    description: "SPLY AND FIXG OF WINDOW OPENABLE,AL 511002300256",
    uom: "square meter",
    rate: "5224.85",
  },
  {
    contract_line: "990",
    tender_line: "990",
    description: "PROVIDING&FXNG,AL SLDNG WNDW,50MCRN,PWDR 521050300115",
    uom: "square meter",
    rate: "4569.38",
  },
  {
    contract_line: "1000",
    tender_line: "1000",
    description: "PROVIDING&FXNG,AL SLDNG WNDW,50MCRN,2TRK 521050300114",
    uom: "square meter",
    rate: "4018.85",
  },
  {
    contract_line: "1010",
    tender_line: "1010",
    description: "PROVIDING&FIXING,AL LVRD VNTLTR 521050300113",
    uom: "square meter",
    rate: "3921.65",
  },
  {
    contract_line: "1020",
    tender_line: "1020",
    description: "SUPPLY,FBRCTN&FXNG,STEEL WINDOWS 521050300112",
    uom: "square meter",
    rate: "3333.28",
  },
  {
    contract_line: "1030",
    tender_line: "1030",
    description: "SUPPLY,FBRCTN&FXNG,STEEL DOOR 521050300111",
    uom: "square meter",
    rate: "2615.87",
  },
  {
    contract_line: "1040",
    tender_line: "1040",
    description: "SUPPLY,FBRCTN&FXNG,MS RLNG SHTR 521050300108",
    uom: "square meter",
    rate: "3495.85",
  },
  {
    contract_line: "1050",
    tender_line: "1050",
    description: "SUPPLY,FBRCTN&FXNG,GRILL,ROLLING SHUTTR 521050300107",
    uom: "square meter",
    rate: "3204.24",
  },
  {
    contract_line: "1060",
    tender_line: "1060",
    description: "PROVIDING&FIXING,MORTICE LOCK,GODREJ 883050300445",
    uom: "Each",
    rate: "961.70",
  },
  {
    contract_line: "1070",
    tender_line: "1070",
    description: "PROVIDING&FIXING,HVY DTY DR CLSR,SIZE 2 521050300106",
    uom: "Each",
    rate: "1952.65",
  },
  {
    contract_line: "1080",
    tender_line: "1080",
    description: "NONASBESTOS CEMENT SHEET-ROOF 511002400002",
    uom: "square meter",
    rate: "509.24",
  },
  {
    contract_line: "1090",
    tender_line: "1090",
    description: "NONASBESTOS CEMENT SHEET -SIDE 519050400017",
    uom: "square meter",
    rate: "509.20",
  },
  {
    contract_line: "1100",
    tender_line: "1100",
    description: "PROVIDING&FIXING,BARRICADING,GI SHT,SPRT 520650300152",
    uom: "square meter",
    rate: "1380.38",
  },
  {
    contract_line: "1110",
    tender_line: "1110",
    description: "PROVIDING&FIXING,GYP BRD FLS CLNG 521003300147",
    uom: "square meter",
    rate: "843.00",
  },
  {
    contract_line: "1120",
    tender_line: "1120",
    description: "EUROPEAN TYPE W/C - WALL 519050400004",
    uom: "Each",
    rate: "10669.06",
  },
  {
    contract_line: "1130",
    tender_line: "1130",
    description: "SUPPLYING & FIXING,EUROPEAN,WTR CLOSET 511201400007",
    uom: "Each",
    rate: "6343.98",
  },
  {
    contract_line: "1140",
    tender_line: "1140",
    description: "SUPPLY&FIXING,WTR CLST,WHITE CLR WALL,PA 511201400001",
    uom: "Each",
    rate: "3784.02",
  },
  {
    contract_line: "1150",
    tender_line: "1150",
    description: "SUP & FIX - WATER CLOSETORISSAPAN,WHITE 511050300900",
    uom: "Each",
    rate: "3726.39",
  },
  {
    contract_line: "1160",
    tender_line: "1160",
    description: "SUPPLYING&FIXING,URINALS,WHITE CLRD 511201400002",
    uom: "Each",
    rate: "4267.45",
  },
  {
    contract_line: "1170",
    tender_line: "1170",
    description: "LARGE URINALS SUPPLY AND FIXING,COLOURED 511201400003",
    uom: "Each",
    rate: "6628.70",
  },
  {
    contract_line: "1180",
    tender_line: "1180",
    description: "URINALS WITH BUILT IN SENSORS 511201400004",
    uom: "Each",
    rate: "10010.15",
  },
  {
    contract_line: "1190",
    tender_line: "1190",
    description: "PROVIDING&FXNG,URNL DVSNL,1200X450X16MM 511201400005",
    uom: "Each",
    rate: "1324.71",
  },
  {
    contract_line: "1200",
    tender_line: "1200",
    description: "PROVIDING&FIXING,URNL DVSNL PLT,CRMC DVR 521050300100",
    uom: "Each",
    rate: "2425.76",
  },
  {
    contract_line: "1210",
    tender_line: "1210",
    description: "HAND WASH BASIN- WHITE COLOUR 511201400006",
    uom: "Each",
    rate: "7735.78",
  },
  {
    contract_line: "1220",
    tender_line: "1220",
    description: "PROVIDING&FIXING,CNTRTP WASHBASIN,OVAL 521050300098",
    uom: "Each",
    rate: "7257.51",
  },
  {
    contract_line: "1230",
    tender_line: "1230",
    description: "SENSOR TAPS FAUCET 511050400009",
    uom: "Each",
    rate: "5782.26",
  },
  {
    contract_line: "1240",
    tender_line: "1240",
    description: "CP TOWEL RING 510802400001",
    uom: "Each",
    rate: "946.22",
  },
  {
    contract_line: "1250",
    tender_line: "1250",
    description: "PROVIDING&FIXING,MIRROR,600X600X 5.5MM 521050300211",
    uom: "Each",
    rate: "1544.92",
  },
  {
    contract_line: "1260",
    tender_line: "1260",
    description: "PROVIDING&FIXING,MIRROR,5.5MM 521050300189",
    uom: "square meter",
    rate: "4291.54",
  },
  {
    contract_line: "1270",
    tender_line: "1270",
    description: "PROVIDING&FIXING,RDYMD BRS SP TRY,W/SCRW 521050300166",
    uom: "Each",
    rate: "841.28",
  },
  {
    contract_line: "1280",
    tender_line: "1280",
    description: "PROVIDING&FXNG,LQD SOAP DSPNSR,RDYMD,BRS 521050300212",
    uom: "Each",
    rate: "841.28",
  },
  {
    contract_line: "1290",
    tender_line: "1290",
    description: "TOILET PAPER HOLDER WC 529050400002",
    uom: "Each",
    rate: "1102.78",
  },
  {
    contract_line: "1300",
    tender_line: "1300",
    description: "PROVIDING&FIXING,BRS TWL RAIL,20X600MM 521050300157",
    uom: "Each",
    rate: "1465.78",
  },
  {
    contract_line: "1310",
    tender_line: "1310",
    description: "15MM DIA STOP COCKS 511050400005",
    uom: "Each",
    rate: "1314.39",
  },
  {
    contract_line: "1320",
    tender_line: "1320",
    description: "15MM DIA BIB COCKS 511050400008",
    uom: "Each",
    rate: "909.23",
  },
  {
    contract_line: "1330",
    tender_line: "1330",
    description: "15MM DIA PILLAR COCKS 511050400006",
    uom: "Each",
    rate: "1009.01",
  },
  {
    contract_line: "1340",
    tender_line: "1340",
    description: "15MM DIA HALF TURN COCKS 511050400007",
    uom: "Each",
    rate: "1314.39",
  },
  {
    contract_line: "1350",
    tender_line: "1350",
    description: "HEALTH FAUCET (HYGI SPRAY) 511050400010",
    uom: "Each",
    rate: "1156.11",
  },
  {
    contract_line: "1360",
    tender_line: "1360",
    description: "PROVIDING&FXNG,15MM CNCLD GI PIPE,MDM 520650300156",
    uom: "meter",
    rate: "259.78",
  },
  {
    contract_line: "1370",
    tender_line: "1370",
    description: "PROVIDING&FXNG,20MM CNCLD GI PIPE,MDM 520650300011",
    uom: "meter",
    rate: "297.63",
  },
  {
    contract_line: "1380",
    tender_line: "1380",
    description: "PROVIDING&FXNG,15MM EXPSD GI PIPE,MDM 520650300155",
    uom: "meter",
    rate: "181.50",
  },
  {
    contract_line: "1390",
    tender_line: "1390",
    description: "PROVIDING&FXNG,20MM EXPSD GI PIPE,MDM 520650300154",
    uom: "meter",
    rate: "209.89",
  },
  {
    contract_line: "1400",
    tender_line: "1400",
    description: "PROVIDING&FXNG,25MM EXPSD GI PIPE,MDM 520650300008",
    uom: "meter",
    rate: "273.54",
  },
  {
    contract_line: "1410",
    tender_line: "1410",
    description: "PROVIDING&FXNG,32MM EXPSD GI PIPE,MDM 520650300153",
    uom: "meter",
    rate: "355.26",
  },
  {
    contract_line: "1420",
    tender_line: "1420",
    description: "SPLY AND LAYG OF PIPE DIA:40MM,GI 511202300815",
    uom: "meter",
    rate: "401.71",
  },
  {
    contract_line: "1430",
    tender_line: "1430",
    description: "SUPPLY&LAYING,CPVC PIPE,SDR11 FTNG,15MM 280103300025",
    uom: "meter",
    rate: "110.11",
  },
  {
    contract_line: "1440",
    tender_line: "1440",
    description: "SUPPLY&LAYING,CPVC PIPE,SDR11 FTNG,20MM 280103300026",
    uom: "meter",
    rate: "143.65",
  },
  {
    contract_line: "1450",
    tender_line: "1450",
    description: "SUPPLY&LAYING,CPVC PIPE,SDR11 FTNG,25MM 280103300027",
    uom: "meter",
    rate: "183.22",
  },
  {
    contract_line: "1460",
    tender_line: "1460",
    description: "SUPPLY&LAYING,CPVC PIPE,SDR11 FTNG,32MM 280103300028",
    uom: "meter",
    rate: "251.18",
  },
  {
    contract_line: "1470",
    tender_line: "1470",
    description: "SUPPLY&LAYING,CPVC PIPE,SDR11 FTNG,40MM 280103300029",
    uom: "meter",
    rate: "350.96",
  },
  {
    contract_line: "1480",
    tender_line: "1480",
    description: "SUPPLY&LAYING,CPVC PIPE,SDR11 FTNG,50MM 280103300030",
    uom: "meter",
    rate: "529.88",
  },
  {
    contract_line: "1490",
    tender_line: "1490",
    description: "40MM DIA GATE VALVE 163338400001",
    uom: "Each",
    rate: "1868.35",
  },
  {
    contract_line: "1500",
    tender_line: "1500",
    description: "32MMDIA GATE VALVE 163338400003",
    uom: "Each",
    rate: "1483.85",
  },
  {
    contract_line: "1510",
    tender_line: "1510",
    description: "25MM DIA GATE VALVE 163338400002",
    uom: "Each",
    rate: "1263.63",
  },
  {
    contract_line: "1520",
    tender_line: "1520",
    description: "15MM DIA GATE VALVE 163338400004",
    uom: "Each",
    rate: "989.23",
  },
  {
    contract_line: "1530",
    tender_line: "1530",
    description: "SUPPLYING&INSTLTN,WTR TANK,HDPE,1000L 521202300014",
    uom: "Each",
    rate: "9205.00",
  },
  {
    contract_line: "1540",
    tender_line: "1540",
    description: "SPLY AND FIXG OF WATER TANK HDPE,500LT 511202301165",
    uom: "Each",
    rate: "5994.29",
  },
  {
    contract_line: "1550",
    tender_line: "1550",
    description: '6" PVC PIPES OF 6 KG/SQCM 519050400015',
    uom: "Running Meter",
    rate: "541.07",
  },
  {
    contract_line: "1560",
    tender_line: "1560",
    description: '4"PVC PIPES OF 6 KG/SQCM 519050400016',
    uom: "Running Meter",
    rate: "312.25",
  },
  {
    contract_line: "1570",
    tender_line: "1570",
    description: "SUPPLY&LAYING,PVC SWR PIPE,80MM 280103300033",
    uom: "meter",
    rate: "236.56",
  },
  {
    contract_line: "1580",
    tender_line: "1580",
    description: "PROVIDING&FIXING,NAHANI TRAP,SLF CLNSNG 521050300210",
    uom: "Each",
    rate: "420.64",
  },
  {
    contract_line: "1590",
    tender_line: "1590",
    description: "PROVIDING&FIXING,GULLY TRAP W/ CHAMBER 521050300085",
    uom: "Each",
    rate: "1847.71",
  },
  {
    contract_line: "1600",
    tender_line: "1600",
    description: "25MM DIA NON RETURN VALVE 460199400003",
    uom: "Each",
    rate: "616.76",
  },
  {
    contract_line: "1610",
    tender_line: "1610",
    description: "15MM DIA NON RETURN VALVE 460199400004",
    uom: "Each",
    rate: "538.49",
  },
  {
    contract_line: "1620",
    tender_line: "1620",
    description: "PROVIDING&FIXING,FLOAT VALVE 521005300028",
    uom: "Each",
    rate: "824.07",
  },
  {
    contract_line: "1630",
    tender_line: "1630",
    description: "PROVIDING&CNSTRCTNG,CHMBR,600X600X600MM 520350300004",
    uom: "Each",
    rate: "5,527.65",
  },
  {
    contract_line: "1640",
    tender_line: "1640",
    description: "PROVIDING&CNSTRCTNG,CHMBR,450X450X600MM 520350300002",
    uom: "Each",
    rate: "5,205.07",
  },
  {
    contract_line: "1650",
    tender_line: "1650",
    description: "PROVIDING&CNSTRT,SPTC TNK,1200X2000X1800 521015300022",
    uom: "Each",
    rate: "36,166.25",
  },
  {
    contract_line: "1660",
    tender_line: "1660",
    description: "PROVIDING&CNSTRCTNG,SEPTIC TANK,75PERSON 521015300021",
    uom: "Each",
    rate: "99,483.85",
  },
  {
    contract_line: "1670",
    tender_line: "1670",
    description: "PROVIDING&CNSTRCTNG,SOAK PIT,2.5X3M 521050300084",
    uom: "Each",
    rate: "17,254.75",
  },
  {
    contract_line: "1680",
    tender_line: "1680",
    description: "PROVIDING&LYNG,PT WRNG-CNCLD CNDT,CU 385050300400",
    uom: "Each",
    rate: "879.12",
  },
  {
    contract_line: "1690",
    tender_line: "1690",
    description: "PROVIDING&LYNG,WRNGCNCLD CNDT,SCKT SWTCH 385050300399",
    uom: "Each",
    rate: "830.09",
  },
  {
    contract_line: "1700",
    tender_line: "1700",
    description: "PROVIDING&LAYING,PT WRNGCNCLD CNDT,SWTCH 385050300398",
    uom: "Each",
    rate: "786.22",
  },
  {
    contract_line: "1710",
    tender_line: "1710",
    description: "PROVIDING&LYNG,WRNGCNCLD CNDT,6/16A SCKT 385050300397",
    uom: "Each",
    rate: "1629.22",
  },
  {
    contract_line: "1720",
    tender_line: "1720",
    description: "PROVIDING&LAYING,PT WRNGCNCLD CNDT,AC PNT 385050300026",
    uom: "Each",
    rate: "2422.32",
  },
  {
    contract_line: "1730",
    tender_line: "1730",
    description: "SUPPLY,LYNG&CMSNG,4X10+1X6MM2 CU CBL 380101300015",
    uom: "meter",
    rate: "626.23",
  },
  {
    contract_line: "1740",
    tender_line: "1740",
    description: "SUPPLY,LYNG&CMSNG,4X6+1X4MM2 CU CBL 380101300018",
    uom: "meter",
    rate: "370.75",
  },
  {
    contract_line: "1750",
    tender_line: "1750",
    description: "SUPPLY,LYNG&CMSNG,1.5MM2 CU CBL,MLTSTRND 380101300013",
    uom: "meter",
    rate: "37.85",
  },
  {
    contract_line: "1760",
    tender_line: "1760",
    description: "SUPPLY,LYNG&CMSNG,2.5MM2 CU CBL,MLTSTRND 380101300012",
    uom: "meter",
    rate: "48.17",
  },
  {
    contract_line: "1770",
    tender_line: "1770",
    description: "SUPPLY,LYNG&CMSNG,4MM2 CU CBL,MLTSTRND 380101300017",
    uom: "meter",
    rate: "68.82",
  },
  {
    contract_line: "1780",
    tender_line: "1780",
    description: "SUPPLY,LYNG&CMSNG,6MM2 CU CBL,MLTSTRND 380101300016",
    uom: "meter",
    rate: "106.66",
  },
  {
    contract_line: "1790",
    tender_line: "1790",
    description: "PVC CONDUIT MED. IS:9537-25MM 390301400007",
    uom: "Running Meter",
    rate: "82.58",
  },
  {
    contract_line: "1800",
    tender_line: "1800",
    description: "PVC CONDUIT MED 32 MM 390301400008",
    uom: "Running Meter",
    rate: "105.80",
  },
  {
    contract_line: "1810",
    tender_line: "1810",
    description: "PVC CONDUIT 40 MM 390301400009",
    uom: "Running Meter",
    rate: "112.69",
  },
  {
    contract_line: "1820",
    tender_line: "1820",
    description: "CEILING FANS 1200 MM SWEEP 390901400001",
    uom: "Each",
    rate: "2673.50",
  },
  {
    contract_line: "1830",
    tender_line: "1830",
    description: "EXHAUST FANS 305MM DIA 390901400002",
    uom: "Each",
    rate: "1761.69",
  },
  {
    contract_line: "1840",
    tender_line: "1840",
    description: "EXHAUST FANS 230MM DIA 390901400003",
    uom: "Each",
    rate: "1522.55",
  },
  {
    contract_line: "1850",
    tender_line: "1850",
    description: "SUPPLY,FXNG&CMSNG,1X36W TB LGHT FTNG,BOX 385050300025",
    uom: "Each",
    rate: "714.83",
  },
  {
    contract_line: "1860",
    tender_line: "1860",
    description: "18W CFL LAMP 391101400001",
    uom: "Each",
    rate: "204.73",
  },
  {
    contract_line: "1870",
    tender_line: "1870",
    description: "13 W CFL LAMP 391101400002",
    uom: "Each",
    rate: "176.34",
  },
  {
    contract_line: "1880",
    tender_line: "1880",
    description: "SUPPLY,2X36W TB LGHT FTNG,W/ LAMP,TCS306 176050300061",
    uom: "Each",
    rate: "1525.99",
  },
  {
    contract_line: "1890",
    tender_line: "1890",
    description: "RECESSMOUNT OPTIC FITTING-2X36 391101400003",
    uom: "Each",
    rate: "1297.18",
  },
  {
    contract_line: "1900",
    tender_line: "1900",
    description: "RECESSMOUNTMIRROR OPTIC-4 X18W 391101400004",
    uom: "Each",
    rate: "1344.49",
  },
  {
    contract_line: "1910",
    tender_line: "1910",
    description: "SUPPLY&LAYING,TLPHN SCKT PNT,4PR,0.5MM 385050300024",
    uom: "Each",
    rate: "596.12",
  },
  {
    contract_line: "1920",
    tender_line: "1920",
    description: "TEL. TAG BLOCK 5 PAIRS 395050400007",
    uom: "Each",
    rate: "760.42",
  },
  {
    contract_line: "1930",
    tender_line: "1930",
    description: "TEL. SOCKET 390301400010",
    uom: "Each",
    rate: "529.02",
  },
  {
    contract_line: "1940",
    tender_line: "1940",
    description: "METER BOARD 390301400011",
    uom: "Each",
    rate: "6943.82",
  },
  {
    contract_line: "1950",
    tender_line: "1950",
    description: "SUPPLY,DLVRY&INSTLTN,PNL BRD,BLW50KVA 380901300029",
    uom: "Each",
    rate: "106319.17",
  },
  {
    contract_line: "1960",
    tender_line: "1960",
    description: "SUPPLY,DLVRY&INSTLTN,PNL BRD,BLW25KVA 381401300006",
    uom: "Each",
    rate: "77000.54",
  },
  {
    contract_line: "1970",
    tender_line: "1970",
    description: "63A TPN MCB DB 390301400012",
    uom: "Each",
    rate: "10118.53",
  },
  {
    contract_line: "1980",
    tender_line: "1980",
    description: "32A TPN MCB DB 390301400013",
    uom: "Each",
    rate: "8372.33",
  },
  {
    contract_line: "1990",
    tender_line: "1990",
    description: "3.5CX 120 SQMM AL CABLE 390101400001",
    uom: "Running Meter",
    rate: "559.13",
  },
  {
    contract_line: "2000",
    tender_line: "2000",
    description: "3.5 C X 95 SQMM AL CABLE 390101400009",
    uom: "Running Meter",
    rate: "432.68",
  },
  {
    contract_line: "2010",
    tender_line: "2010",
    description: "3.5CX 70 SQMM AL CABLE 390101400002",
    uom: "Running Meter",
    rate: "305.37",
  },
  {
    contract_line: "2020",
    tender_line: "2020",
    description: "3.5CX 50 SQMM AL CABLE 390101400003",
    uom: "Running Meter",
    rate: "254.62",
  },
  {
    contract_line: "2030",
    tender_line: "2030",
    description: "3.5CX35SQMM AL CABLE 390101400004",
    uom: "Running Meter",
    rate: "227.95",
  },
  {
    contract_line: "2040",
    tender_line: "2040",
    description: "4CX35SQMM AL CABLE 390101400005",
    uom: "Running Meter",
    rate: "173.76",
  },
  {
    contract_line: "2050",
    tender_line: "2050",
    description: "4CX6SQMM AL CABLE 390101400006",
    uom: "Running Meter",
    rate: "98.92",
  },
  {
    contract_line: "2060",
    tender_line: "2060",
    description: "4CX2.5SQMM COPPER CABLE 390101400007",
    uom: "Running Meter",
    rate: "172.04",
  },
  {
    contract_line: "2070",
    tender_line: "2070",
    description: "3CX6 SQMM AL CABLE 390101400008",
    uom: "Running Meter",
    rate: "102.36",
  },
  {
    contract_line: "2080",
    tender_line: "2080",
    description: "SUPPLY,END TRMNTN,AL CBL,3.5CX120MM2 380102300011",
    uom: "Each",
    rate: "626.23",
  },
  {
    contract_line: "2090",
    tender_line: "2090",
    description: "SUPPLY,END TRMNTN,AL CBL,3.5CX95MM2 380102300010",
    uom: "Each",
    rate: "540.21",
  },
  {
    contract_line: "2100",
    tender_line: "2100",
    description: "SUPPLY,END TRMNTN,AL CBL,3.5CX70MM2 380102300009",
    uom: "Each",
    rate: "374.19",
  },
  {
    contract_line: "2110",
    tender_line: "2110",
    description: "SUPPLY,END TRMNTN,CBL,3.5CX50MM2 380101301064",
    uom: "Each",
    rate: "318.27",
  },
  {
    contract_line: "2120",
    tender_line: "2120",
    description: "SUPPLY,END TRMNTN,CBL,3.5CX50MM2 380101301065",
    uom: "Each",
    rate: "286.45",
  },
  {
    contract_line: "2130",
    tender_line: "2130",
    description: "SUPPLY,END TRMNTN,CBL,4CX16MM2 380102300006",
    uom: "Each",
    rate: "214.19",
  },
  {
    contract_line: "2140",
    tender_line: "2140",
    description: "SUPPLY,END TRMNTN,CBL,4CX6MM2 380102300005",
    uom: "Each",
    rate: "122.15",
  },
  {
    contract_line: "2150",
    tender_line: "2150",
    description: "SUPPLY,END TRMNTN,CBL,4CX2.5MM2,NFLPGLND 380102300004",
    uom: "Each",
    rate: "135.05",
  },
  {
    contract_line: "2160",
    tender_line: "2160",
    description: "SUPPLY,END TRMNTN,CBL,3CX2.5MM2,NFLPGLND 380101301063",
    uom: "Each",
    rate: "135.91",
  },
  {
    contract_line: "2170",
    tender_line: "2170",
    description: "SUPPLY,END TRMNTN,CBL,4CX2.5MM2,FLP GLND 380102300002",
    uom: "Each",
    rate: "238.28",
  },
  {
    contract_line: "2180",
    tender_line: "2180",
    description: "SUPPLY,END TRMNTN,CBL,3CX2.5MM2,FLP GLND 380102300015",
    uom: "Each",
    rate: "238.28",
  },
  {
    contract_line: "2190",
    tender_line: "2190",
    description: "CABLE TRENCH EXCAVATION 520903400001",
    uom: "Running Meter",
    rate: "216.77",
  },
  {
    contract_line: "2200",
    tender_line: "2200",
    description: "JUNCTION BOX-FLP 390301400014",
    uom: "Each",
    rate: "1,030.52",
  },
  {
    contract_line: "2210",
    tender_line: "2210",
    description: "JUNCTION BOX-NFLP 390301400015",
    uom: "Each",
    rate: "744.07",
  },
  {
    contract_line: "2220",
    tender_line: "2220",
    description: "SUPPLY&INSTALLATION,OCTGNL GI PL,6M,SNGL 176050300060",
    uom: "Each",
    rate: "13678.90",
  },
  {
    contract_line: "2230",
    tender_line: "2230",
    description: "SUPPLY&INSTALLATION,OCTGNL GI PL,6M,DBL 176050300059",
    uom: "Each",
    rate: "14114.16",
  },
  {
    contract_line: "2240",
    tender_line: "2240",
    description: "SUPPLY&INSTALLATION,GRP-SNGL ARM PL 6M 176050300058",
    uom: "Each",
    rate: "16656.91",
  },
  {
    contract_line: "2250",
    tender_line: "2250",
    description: "SUPPLY&INSTALLATION,GRP-DBL ARM PL 6M,CN 176050300057",
    uom: "Each",
    rate: "17745.07",
  },
  {
    contract_line: "2260",
    tender_line: "2260",
    description: "SUPPLY&FIXING,HRDNG LGHT FXTR 70W 381150300007",
    uom: "Each",
    rate: "7122.46",
  },
  {
    contract_line: "2270",
    tender_line: "2270",
    description: "FIX.HPCLSUPPLIED STREET LIGHT. 370106400003",
    uom: "Each",
    rate: "862.78",
  },
  {
    contract_line: "2280",
    tender_line: "2280",
    description: "FIX HPCLSUPPLIED HOARDINGLIGHT 370106400004",
    uom: "Each",
    rate: "1483.85",
  },
  {
    contract_line: "2290",
    tender_line: "2290",
    description: "PROVIDING,EARTHING,ELCTRD PLT,3.2M 380802300004",
    uom: "Each",
    rate: "12606.23",
  },
  {
    contract_line: "2300",
    tender_line: "2300",
    description: "PROVIDING,EARTHING,ELCTRD PLT,3.75M 380802300007",
    uom: "Each",
    rate: "6524.62",
  },
  {
    contract_line: "2310",
    tender_line: "2310",
    description: "10 SWG COPPER WIRE 390101400010",
    uom: "Running Meter",
    rate: "174.62",
  },
  {
    contract_line: "2320",
    tender_line: "2320",
    description: "SUPPLY&LYNG,CNCTN&TSTNG,ERT,GI FLT,50X6 380101301067",
    uom: "meter",
    rate: "340.64",
  },
  {
    contract_line: "2330",
    tender_line: "2330",
    description: "SUP & LAY - EARTH STRIPINST&CONN,25X6MM 380301400002",
    uom: "meter",
    rate: "150.53",
  },
  {
    contract_line: "2340",
    tender_line: "2340",
    description: "MS CHEQURED PLATE 6MM 390301400016",
    uom: "kilogram",
    rate: "75.70",
  },
  {
    contract_line: "2350",
    tender_line: "2350",
    description: "EMERGENCYSWITCH (MASHRUM) 390301400017",
    uom: "Each",
    rate: "1201.70",
  },
  {
    contract_line: "2360",
    tender_line: "2360",
    description: "S & F CANOPY LIGHT FIXTURES 150W 511806400002",
    uom: "Each",
    rate: "4777.55",
  },
  {
    contract_line: "2370",
    tender_line: "2370",
    description: "FIX- HPCL SUPPLIED CANOPY LIGHT 511806400003",
    uom: "Each",
    rate: "474.83",
  },
  {
    contract_line: "2380",
    tender_line: "2380",
    description: "ISI MARKED RUBBER MAT-12MM 390301400018",
    uom: "square meter",
    rate: "1562.98",
  },
  {
    contract_line: "2390",
    tender_line: "2390",
    description: "SUPPLY,INSTLTN&CMSNG,1PH SRVSTBLSR 5KVA 385050300023",
    uom: "Each",
    rate: "11475.07",
  },
  {
    contract_line: "2400",
    tender_line: "2400",
    description: "SUPPLY&FIXING,CNSTNT VLTG TRNSFRMR,250VA 385050300022",
    uom: "Each",
    rate: "4818.84",
  },
  {
    contract_line: "2410",
    tender_line: "2410",
    description: "SUPPLY&FIXING,CNSTNT VLTG TRNSFRMR,500VO 391601400001",
    uom: "Each",
    rate: "6507.41",
  },
  {
    contract_line: "2420",
    tender_line: "2420",
    description: "SUPPLY,FILLING MTRL W/GSB,150MM 176050300056",
    uom: "square meter",
    rate: "295.91",
  },
  {
    contract_line: "2430",
    tender_line: "2430",
    description: "PROVIDING&LAYING,WBM,1ST LAYER,100MM 520506300005",
    uom: "square meter",
    rate: "257.20",
  },
  {
    contract_line: "2440",
    tender_line: "2440",
    description: "PROVIDING&LAYING,WBM,2ND LAYER,75MM 520506300004",
    uom: "square meter",
    rate: "220.21",
  },
  {
    contract_line: "2450",
    tender_line: "2450",
    description: "PROVIDING&LAYING,WBM,3RD LAYER,75MM 520506300001",
    uom: "square meter",
    rate: "190.10",
  },
  {
    contract_line: "2460",
    tender_line: "2460",
    description: "PROVIDING&LAYING,BBM,100MM THK 520702300005",
    uom: "square meter",
    rate: "576.33",
  },
  {
    contract_line: "2470",
    tender_line: "2470",
    description: "PROVIDING&LAYING,BM,75MM,60/70GR D BTMN 520702300004",
    uom: "square meter",
    rate: "432.68",
  },
  {
    contract_line: "2480",
    tender_line: "2480",
    description: "PROVIDING&LAYING,SM DNS BTMNS CNCRT,25MM 520702300003",
    uom: "square meter",
    rate: "288.81",
  },
  {
    contract_line: "2490",
    tender_line: "2490",
    description: "PROVIDING&LAYING,SM DNS BTMNS CNCRT,40MM 520702300002",
    uom: "square meter",
    rate: "366.45",
  },
  {
    contract_line: "2500",
    tender_line: "2500",
    description: "PROVIDING&LAYING,SMDNS BTMNS CNCRT,100M 510250400001",
    uom: "square meter",
    rate: "658.05",
  },
  {
    contract_line: "2510",
    tender_line: "2510",
    description: "PROVIDING&LAYING,PREMIX CARPET,50MM 520302300109",
    uom: "square meter",
    rate: "377.63",
  },
  {
    contract_line: "2520",
    tender_line: "2520",
    description: "PROVIDING&LAYING,PREMIX CARPET,100MM 520302300110",
    uom: "square meter",
    rate: "755.26",
  },
  {
    contract_line: "2530",
    tender_line: "2530",
    description: "PROVIDING&LAYING,SEAL COAT,12MM 520504300001",
    uom: "square meter",
    rate: "141.93",
  },
  {
    contract_line: "2540",
    tender_line: "2540",
    description: "PROVIDING&LAYING,MASTIC WRNG COARSE,25MM 520302300108",
    uom: "square meter",
    rate: "721.71",
  },
  {
    contract_line: "2550",
    tender_line: "2550",
    description: "PROVIDING&FIXING,RSD PAVEMENT MRKR,HD HP 520250300013",
    uom: "Each",
    rate: "193.54",
  },
  {
    contract_line: "2560",
    tender_line: "2560",
    description: "PROVIDING&FIXING,LNR DLNTN SHTNG 3M 512501400001",
    uom: "square meter",
    rate: "572.03",
  },
  {
    contract_line: "2570",
    tender_line: "2570",
    description: "SUPPLY&LAYING,GREY PAVER,80MM 176050300055",
    uom: "square meter",
    rate: "812.89",
  },
  {
    contract_line: "2580",
    tender_line: "2580",
    description: "SUPPLY&LAYING,GREY PAVER,CLR,80MM 176050300054",
    uom: "square meter",
    rate: "838.70",
  },
  {
    contract_line: "2590",
    tender_line: "2590",
    description: "SUPPLY&LAYING,GREY PAVER,80MM,LACQUER 176050300053",
    uom: "square meter",
    rate: "942.78",
  },
  {
    contract_line: "2600",
    tender_line: "2600",
    description: "SUPPLY&LAYING,PAVER,80MM,LACQUER FINISH 176050300052",
    uom: "square meter",
    rate: "1072.67",
  },
  {
    contract_line: "2610",
    tender_line: "2610",
    description: "RELAYING,EXISTING OLD PAVER,INLN&LVL 521050300083",
    uom: "square meter",
    rate: "190.96",
  },
  {
    contract_line: "2620",
    tender_line: "2620",
    description: "DRESSING,EXISTING DRIVEWAY 521050300082",
    uom: "square meter",
    rate: "41.29",
  },
  {
    contract_line: "2630",
    tender_line: "2630",
    description: "PROVIDING&ERCTNG,RCC PRCST,300X150X300MM 520202300006",
    uom: "meter",
    rate: "333.76",
  },
  {
    contract_line: "2640",
    tender_line: "2640",
    description: "PROVIDING&LAYING,RCC DRVWY 1:2:4,150MM 520202300005",
    uom: "cubic meter",
    rate: "6248.49",
  },
  {
    contract_line: "2650",
    tender_line: "2650",
    description: "RCC DRIVEWAY WITH 1:1.5:3 NOMINAL MIX 520550400001",
    uom: "cubic meter",
    rate: "7054.50",
  },
  {
    contract_line: "2660",
    tender_line: "2660",
    description: "PROVIDING&LAYING,RCC,RDYMX,150MM,W/M-25 520202300132",
    uom: "cubic meter",
    rate: "6635.58",
  },
  {
    contract_line: "2670",
    tender_line: "2670",
    description: "PROVIDING&LYNG,RCC DRVWY 1:2:4,150MM 520202300003",
    uom: "cubic meter",
    rate: "6331.07",
  },
  {
    contract_line: "2680",
    tender_line: "2680",
    description: "PROVIDING&LAYING,PRECST RCC,FCTRY MD,M35 520202300002",
    uom: "square meter",
    rate: "2804.25",
  },
  {
    contract_line: "2690",
    tender_line: "2690",
    description: "PROVIDING CNSTRCTNG,INSPCN CHMBR,600X600 510301400003",
    uom: "Each",
    rate: "6695.80",
  },
  {
    contract_line: "2700",
    tender_line: "2700",
    description: "PROVIDING&CNSTRCTNG,INSPCN CHMBR450X450 510301400005",
    uom: "Each",
    rate: "4206.38",
  },
  {
    contract_line: "2710",
    tender_line: "2710",
    description: "900X900MMD.I.COVER(HEAVY DUTY) 186001400002",
    uom: "Each",
    rate: "19068.05",
  },
  {
    contract_line: "2720",
    tender_line: "2720",
    description: "600X600MMD.I.COVER(HEAVY DUTY) 186001400003",
    uom: "Each",
    rate: "13390.73",
  },
  {
    contract_line: "2730",
    tender_line: "2730",
    description: "450X450MMD.I.COVER(HEAVY DUTY) 186001400004",
    uom: "Each",
    rate: "9132.74",
  },
  {
    contract_line: "2740",
    tender_line: "2740",
    description: "TRAN.70 KLTANK- 50 KM 883050400002",
    uom: "Each",
    rate: "17059.49",
  },
  {
    contract_line: "2750",
    tender_line: "2750",
    description: "TRANS.45 KL WITHIN 50 KM 883050400003",
    uom: "Each",
    rate: "13820.83",
  },
  {
    contract_line: "2760",
    tender_line: "2760",
    description: "TRANSP. OF 35/22/16 KL WITHIN 50 KM 176050400015",
    uom: "Each",
    rate: "11641.09",
  },
  {
    contract_line: "2770",
    tender_line: "2770",
    description: "TRANSP. OF 9 KL WITHIN 50 KM 883050400004",
    uom: "Each",
    rate: "11641.09",
  },
  {
    contract_line: "2780",
    tender_line: "2780",
    description: "TRANSPORTATION OF CHARGES BEYOND 50KM 176050300323",
    uom: "Kilometer",
    rate: "28.39",
  },
  {
    contract_line: "2790",
    tender_line: "2790",
    description: "TRANSP. OF MONO/DUEL DU<50KM LOT-5NO 172104400001",
    uom: "LOT",
    rate: "2085.12",
  },
  {
    contract_line: "2800",
    tender_line: "2800",
    description: "TRANSP. OF MPD<50 KM LOT UPTO 5 NO 172104400002",
    uom: "LOT",
    rate: "4028.32",
  },
  {
    contract_line: "2810",
    tender_line: "2810",
    description: "INSTALLATION,TANK 45KL,ERTH PIT/UNDR DRV 521050300149",
    uom: "Each",
    rate: "25719.12",
  },
  {
    contract_line: "2820",
    tender_line: "2820",
    description: "INSTALLATION,TANK 35KL,ERTH PIT/UNDR DRV 521050300150",
    uom: "Each",
    rate: "23080.89",
  },
  {
    contract_line: "2830",
    tender_line: "2830",
    description: "INSTALLATION,TANK 22KL,ERTH PIT/UNDR DRV 521050300151",
    uom: "Each",
    rate: "17190.24",
  },
  {
    contract_line: "2840",
    tender_line: "2840",
    description: "INSTALLATION,TANK 16KL,ERTH PIT/UNDR DRV 521050300152",
    uom: "Each",
    rate: "14858.23",
  },
  {
    contract_line: "2850",
    tender_line: "2850",
    description: "INSTALLATION,TANK 9KL,ERTH PT/UNDR DRVWY 521050300153",
    uom: "Each",
    rate: "11461.30",
  },
  {
    contract_line: "2860",
    tender_line: "2860",
    description: "FABRICATING&FIXING,SS RAILING 521050300219",
    uom: "meter",
    rate: "2590.06",
  },
  {
    contract_line: "2870",
    tender_line: "2870",
    description: "SLY AND FAB OF PIPE DIA:80MM,MS GROUTIN 280101400002",
    uom: "meter",
    rate: "974.61",
  },
  {
    contract_line: "2880",
    tender_line: "2880",
    description: "CONSTRUCTION,PUMP ISLAND,1M,W/BRCKMSNRY 521050300222",
    uom: "meter",
    rate: "2655.44",
  },
  {
    contract_line: "2890",
    tender_line: "2890",
    description: "INSTALLATION OF MONO / DUEL PUMPS 176001400001",
    uom: "Each",
    rate: "1446.86",
  },
  {
    contract_line: "2900",
    tender_line: "2900",
    description: "INSTALLATION OF DUAL PUMPS 176001400002",
    uom: "Each",
    rate: "1446.86",
  },
  {
    contract_line: "2910",
    tender_line: "2910",
    description: "INSTALLATION OF MPD PUMPS 176001400003",
    uom: "Each",
    rate: "3102.74",
  },
  {
    contract_line: "2920",
    tender_line: "2920",
    description: "SUPPLY&LYNG,MS SCRWD PIPELINE,C-CLS,40MM 280103300034",
    uom: "meter",
    rate: "501.50",
  },
  {
    contract_line: "2930",
    tender_line: "2930",
    description: "SUPPLY&LYNG,MS SCRWD PIPELINE,C-CLS,50MM 280103300035",
    uom: "meter",
    rate: "681.28",
  },
  {
    contract_line: "2940",
    tender_line: "2940",
    description: "SUPPLY&LYNG,MS SCRWD PIPELINE,C-CLS,80MM 280103300036",
    uom: "meter",
    rate: "1032.24",
  },
  {
    contract_line: "2950",
    tender_line: "2950",
    description: "SUPPLY&LYNG,MS WELDED PIPELINE,C-CLS,40M 185403400001",
    uom: "meter",
    rate: "545.37",
  },
  {
    contract_line: "2960",
    tender_line: "2960",
    description: "SUPPLY&LYNG,MS WELDED PL,C,50MM,5KG/CM2 185403400002",
    uom: "meter",
    rate: "732.89",
  },
  {
    contract_line: "2970",
    tender_line: "2970",
    description: "SUPPLY&LYNG,MS WELDED PL,C,80MM,5KG/CM2 185403400003",
    uom: "meter",
    rate: "1113.10",
  },
  {
    contract_line: "2980",
    tender_line: "2980",
    description: "FLANGE JOINT 40MM DIA 180101400001",
    uom: "Each",
    rate: "241.72",
  },
  {
    contract_line: "2990",
    tender_line: "2990",
    description: "FLANGE JOINT 50MM DIA 180101400002",
    uom: "Each",
    rate: "274.40",
  },
  {
    contract_line: "3000",
    tender_line: "3000",
    description: "SUPPLY OF BALL VALVES 40MM DIA 160336400002",
    uom: "Each",
    rate: "2963.39",
  },
  {
    contract_line: "3010",
    tender_line: "3010",
    description: "S/F BALL VALVES 50MM DIA 160336400003",
    uom: "Each",
    rate: "3512.20",
  },
  {
    contract_line: "3020",
    tender_line: "3020",
    description: "INSTALLATION OF STP 176001400004",
    uom: "Each",
    rate: "2024.05",
  },
  {
    contract_line: "3030",
    tender_line: "3030",
    description: "AL FILL CAP 180101400003",
    uom: "Each",
    rate: "1102.82",
  },
  {
    contract_line: "3040",
    tender_line: "3040",
    description: "AL DIP CAP 180101400004",
    uom: "Each",
    rate: "843.00",
  },
  {
    contract_line: "3050",
    tender_line: "3050",
    description: "GRANITE SLAB 511007400002",
    uom: "square meter",
    rate: "2237.38",
  },
  {
    contract_line: "3060",
    tender_line: "3060",
    description: "GRANITE TILES 10MM 511007400004",
    uom: "square meter",
    rate: "1666.21",
  },
  {
    contract_line: "3070",
    tender_line: "3070",
    description: "SILICA GEL TRAP 270102400002",
    uom: "Each",
    rate: "2121.25",
  },
  {
    contract_line: "3080",
    tender_line: "3080",
    description: "TEE VENT HOOD 186001400005",
    uom: "Each",
    rate: "1,813.30",
  },
  {
    contract_line: "3090",
    tender_line: "3090",
    description: "EXHUMING,UG TANK,9KL,W/ALL FTNG 520950300005",
    uom: "Each",
    rate: "9721.98",
  },
  {
    contract_line: "3100",
    tender_line: "3100",
    description: "EXHUMING,UG TANK,14/16KL,W/ALL FTNG 520950300004",
    uom: "Each",
    rate: "11168.84",
  },
  {
    contract_line: "3110",
    tender_line: "3110",
    description: "EXHUMING,UG TANK,22KL,W/ALL FTNG 520950300021",
    uom: "Each",
    rate: "11924.09",
  },
  {
    contract_line: "3120",
    tender_line: "3120",
    description: "EXHUMING,UG TANK,45KL,W/ALL FTNG 520950300020",
    uom: "Each",
    rate: "14016.96",
  },
  {
    contract_line: "3130",
    tender_line: "3130",
    description: "EXHUMING,UG TANK,70KL,W/ALL FTNG 520950300001",
    uom: "Each",
    rate: "18341.18",
  },
  {
    contract_line: "3140",
    tender_line: "3140",
    description: "DISMANTLING OF P/ISLAND 520350400001",
    uom: "square meter",
    rate: "666.65",
  },
  {
    contract_line: "3150",
    tender_line: "3150",
    description: "DISMANTLING OF RCC TANK 520650400001",
    uom: "cubic meter",
    rate: "1083.85",
  },
  {
    contract_line: "3160",
    tender_line: "3160",
    description: "REMOVAL OF AC SHEET 529050400003",
    uom: "square meter",
    rate: "44.73",
  },
  {
    contract_line: "3170",
    tender_line: "3170",
    description: "REMOVAL OF ST. STEEL 520650400004",
    uom: "Metric ton",
    rate: "4123.80",
  },
  {
    contract_line: "3180",
    tender_line: "3180",
    description: "EXCAVATION IN RCC EXCAVATION IN RCC 520903300256",
    uom: "cubic meter",
    rate: "1616.32",
  },
  {
    contract_line: "3190",
    tender_line: "3190",
    description: "DIS. OF BRICK MASONARY 510301400006",
    uom: "cubic meter",
    rate: "377.63",
  },
  {
    contract_line: "3200",
    tender_line: "3200",
    description: "DISMANTLING,FALSE CEILING 521003300152",
    uom: "square meter",
    rate: "68.82",
  },
  {
    contract_line: "3210",
    tender_line: "3210",
    description: "REMOVAL OF MS/AL DOORS 521002400001",
    uom: "square meter",
    rate: "94.62",
  },
  {
    contract_line: "3220",
    tender_line: "3220",
    description: "SHIFTING,EB MAIN,LAISONING W/EB OFCL 385050300396",
    uom: "Lump Sum",
    rate: "5663.56",
  },
  {
    contract_line: "3230",
    tender_line: "3230",
    description: "REMOVING,EXSTNG ID SIGN,CRFLY W/ODMG&SHF 883050300444",
    uom: "Each",
    rate: "2563.40",
  },
  {
    contract_line: "3240",
    tender_line: "3240",
    description: "REMOVAL OF YARD LIGHT POLE 520650400003",
    uom: "Each",
    rate: "1073.53",
  },
  {
    contract_line: "3250",
    tender_line: "3250",
    description: "REMOVING,CHNLNK/BRBD WR FNCNG 520650300148",
    uom: "square meter",
    rate: "25.81",
  },
  {
    contract_line: "3260",
    tender_line: "3260",
    description: "REMOVING OF MONO / DUEL PUMPS 154001400001",
    uom: "Each",
    rate: "747.51",
  },
  {
    contract_line: "3270",
    tender_line: "3270",
    description: "REMOVING OF EXTNG DSPNSNG PUMP,MPD 154002400002",
    uom: "Each",
    rate: "970.31",
  },
  {
    contract_line: "3280",
    tender_line: "3280",
    description: "RELAYING,MS THRD PIPELIN,40MM,W/HD FTNG 280103300040",
    uom: "meter",
    rate: "281.29",
  },
  {
    contract_line: "3290",
    tender_line: "3290",
    description: "RELAYING,MS THRD PIPELIN,50MM,W/HD FTNG 280103300041",
    uom: "meter",
    rate: "300.21",
  },
  {
    contract_line: "3300",
    tender_line: "3300",
    description: "RELAYING,MS THRD PIPELIN,80MM,W/HD FTNG 280103300042",
    uom: "meter",
    rate: "396.55",
  },
  {
    contract_line: "3310",
    tender_line: "3310",
    description: "FILL PIPE BRASS COUPLING 186001400006",
    uom: "Each",
    rate: "1592.23",
  },
  {
    contract_line: "3320",
    tender_line: "3320",
    description: "INSTLN. OF AIR TOWER 520650400005",
    uom: "Each",
    rate: "2260.61",
  },
  {
    contract_line: "3330",
    tender_line: "3330",
    description: "CABLE TRAY-300 MM WIDE 390201400001",
    uom: "Running Meter",
    rate: "578.05",
  },
  {
    contract_line: "3340",
    tender_line: "3340",
    description: "CABLE TRAY-150 MM WIDE 390201400002",
    uom: "Running Meter",
    rate: "353.54",
  },
  {
    contract_line: "3350",
    tender_line: "3350",
    description: "SUPPLY,GASKET PACKING,MNHL TNK INSTLTN 176050300048",
    uom: "square meter",
    rate: "1017.62",
  },
  {
    contract_line: "3360",
    tender_line: "3360",
    description: "HEAVYDUTY BRASS CROCODILE CLIP 390301400019",
    uom: "Each",
    rate: "2108.35",
  },
  {
    contract_line: "3370",
    tender_line: "3370",
    description: "SUPPLY,FIXING AND EMBEDDING O,49RU000373 176050300006",
    uom: "kilogram",
    rate: "88.60",
  },
  {
    contract_line: "3380",
    tender_line: "3380",
    description: "SUPPLYING&TRNSPT,FBRCTNG,ERCTG,STL STR 176050300047",
    uom: "Metric ton",
    rate: "93895.98",
  },
  {
    contract_line: "3390",
    tender_line: "3390",
    description: "DRILLING,PRFCTLY VRTCL BORE,150MM 529050301214",
    uom: "meter",
    rate: "298.49",
  },
  {
    contract_line: "3400",
    tender_line: "3400",
    description: 'S&F OF UPVC PIPE -6" DIA 519050400018',
    uom: "Running Meter",
    rate: "933.32",
  },
  {
    contract_line: "3410",
    tender_line: "3410",
    description: 'S&F OF SCREEN PIPE- 6" DIA 519050400019',
    uom: "Running Meter",
    rate: "618.48",
  },
  {
    contract_line: "3420",
    tender_line: "3420",
    description: "CONDUCTING,YIELD TEST,DVLPMNT TUBE WELL 176050300044",
    uom: "Each",
    rate: "2014.59",
  },
  {
    contract_line: "3430",
    tender_line: "3430",
    description: "SUPPLY&PROVIDING,TSTNG,CMSNG,SUB PUMP2HP 176050300043",
    uom: "Each",
    rate: "18122.69",
  },
  {
    contract_line: "3440",
    tender_line: "3440",
    description: "PROVIDING&FIXING,WELL CAP,MS,150MM 520650300005",
    uom: "Each",
    rate: "633.11",
  },
  {
    contract_line: "3450",
    tender_line: "3450",
    description: "S&F OF 40 MM DIA NB HDPE PIPE 186050400004",
    uom: "Running Meter",
    rate: "258.92",
  },
  {
    contract_line: "3460",
    tender_line: "3460",
    description: "3 C X 2.5 COPPER FLAT CABLE 390101400011",
    uom: "Running Meter",
    rate: "117.85",
  },
  {
    contract_line: "3470",
    tender_line: "3470",
    description: "SINGLE PHASE 1.5 HP JET PUMP 182101400001",
    uom: "Each",
    rate: "8495.34",
  },
  {
    contract_line: "3480",
    tender_line: "3480",
    description: "25 MM NB HDPE PIPE 519050400014",
    uom: "Running Meter",
    rate: "73.12",
  },
  {
    contract_line: "3490",
    tender_line: "3490",
    description: "CARRYING OUT,GLGCL TSTNG F/BRWL 176050300042",
    uom: "Each",
    rate: "2118.67",
  },
  {
    contract_line: "3500",
    tender_line: "3500",
    description: "SPLY & FAB OF STR STEELWELDING&ERECTION 185301300052",
    uom: "Metric ton",
    rate: "81835.20",
  },
  {
    contract_line: "3510",
    tender_line: "3510",
    description: "STEEL GRATING 519050400005",
    uom: "kilogram",
    rate: "112.42",
  },
  {
    contract_line: "3520",
    tender_line: "3520",
    description: "TEXTURED PAINT 320101400001",
    uom: "square meter",
    rate: "136.15",
  },
  {
    contract_line: "3530",
    tender_line: "3530",
    description: "UNDER REAMED PILE RATIO:1:1.5:3,DIA:400M 520202300155",
    uom: "meter",
    rate: "1869.21",
  },
  {
    contract_line: "3540",
    tender_line: "3540",
    description: "CONST - UNDER REAMED PILERCC,1:1.5:3,300 520202300101",
    uom: "meter",
    rate: "1487.29",
  },
  {
    contract_line: "3550",
    tender_line: "3550",
    description: "SUP & FIX - HAND RAILINGSSS304,900MM,STAI 510601300201",
    uom: "Running Meter",
    rate: "1738.46",
  },
  {
    contract_line: "3560",
    tender_line: "3560",
    description: "PROVIDING&LAYING,UPVC PIPE,15MM,4KG/CM2 280103300019",
    uom: "meter",
    rate: "129.03",
  },
  {
    contract_line: "3570",
    tender_line: "3570",
    description: "PROVIDING&LAYING,UPVC PIPE,20MM,4KG/CM2 280103300020",
    uom: "meter",
    rate: "153.12",
  },
  {
    contract_line: "3580",
    tender_line: "3580",
    description: "PROVIDING&LAYING,UPVC PIPE,25MM,4KG/CM2 280103300021",
    uom: "meter",
    rate: "197.85",
  },
  {
    contract_line: "3590",
    tender_line: "3590",
    description: "PROVIDING&LAYING,UPVC PIPE,32MM,4KG/CM2 280103300022",
    uom: "meter",
    rate: "246.02",
  },
  {
    contract_line: "3600",
    tender_line: "3600",
    description: "PROVIDING LAYING,UPVC PIPE,40MM,4KG/CM2 520601400001",
    uom: "meter",
    rate: "283.87",
  },
  {
    contract_line: "3610",
    tender_line: "3610",
    description: "PROVIDING&LAYING,UPVC PIPE,50MM,4KG/CM2 280103300024",
    uom: "meter",
    rate: "292.47",
  },
  {
    contract_line: "3620",
    tender_line: "3620",
    description: "PROVIDING&FIXING,MS FAN HOOKS 176050300062",
    uom: "Each",
    rate: "270.96",
  },
  {
    contract_line: "3630",
    tender_line: "3630",
    description: "SPLY&LAYG OF DAMP PROOF COURSE THK:50MM 511050300899",
    uom: "square meter",
    rate: "328.60",
  },
  {
    contract_line: "3640",
    tender_line: "3640",
    description: "SUP & LAY - PCCRATIO:1:1.5:3,F/COPPING 510201300200",
    uom: "cubic meter",
    rate: "5320.34",
  },
  {
    contract_line: "3650",
    tender_line: "3650",
    description: "SPLY AND LAYG OF CONCRETE READY MIX,M20 510250300328",
    uom: "cubic meter",
    rate: "6172.80",
  },
  {
    contract_line: "3660",
    tender_line: "3660",
    description: "UNDER REAMED PILES 300 MMUNDERREAMED PIL 520202300242",
    uom: "meter",
    rate: "1528.58",
  },
  {
    contract_line: "3670",
    tender_line: "3670",
    description: "UNDER REAMED PILES 250 MM -- 520202300241",
    uom: "meter",
    rate: "1381.48",
  },
  {
    contract_line: "3680",
    tender_line: "3680",
    description: "SUP & CONST - BMOLD,1:5,SCAFFOLDING & SO 510301400291",
    uom: "cubic meter",
    rate: "1859.75",
  },
  {
    contract_line: "3690",
    tender_line: "3690",
    description: "SPLY & CONST OF BMOLD,1:5,SCAFFOLDING 510301400292",
    uom: "cubic meter",
    rate: "2039.53",
  },
  {
    contract_line: "3700",
    tender_line: "3700",
    description: "SPLY & CONST OF BMFLY ASH,FIRST,1:5 510301300351",
    uom: "cubic meter",
    rate: "5925.06",
  },
  {
    contract_line: "3710",
    tender_line: "3710",
    description: "SPLY & CONST OF BRICK MASONRY-SUPER STRU 510301400002",
    uom: "cubic meter",
    rate: "6245.05",
  },
  {
    contract_line: "3720",
    tender_line: "3720",
    description: "SUP & FIX - GRANITE SLABWD:0.8MTXLG:1.2M 510450300185",
    uom: "square meter",
    rate: "2893.71",
  },
  {
    contract_line: "3730",
    tender_line: "3730",
    description: "SPLY AND LAYG OF FLAT GI,25X3MM 390802300142",
    uom: "meter",
    rate: "90.32",
  },
  {
    contract_line: "3740",
    tender_line: "3740",
    description: "EXCAVATION FOR FDNSOFT ROCK,UPTO 1.5MT 520903300586",
    uom: "cubic meter",
    rate: "209.03",
  },
  {
    contract_line: "3750",
    tender_line: "3750",
    description: "EXCAVATION FOR FDNSOFT ROCK,1.5-3MT 520903300585",
    uom: "cubic meter",
    rate: "245.61",
  },
  {
    contract_line: "3760",
    tender_line: "3760",
    description: "EXCAVATION FOR FDNSOFT ROCK,3-4.5MT 520903300587",
    uom: "cubic meter",
    rate: "522.57",
  },
  {
    contract_line: "3770",
    tender_line: "3770",
    description: "SPLY AND LAY OF BMFLY ASH,115MM,1:4 510301300352",
    uom: "cubic meter",
    rate: "5036.47",
  },
  {
    contract_line: "3780",
    tender_line: "3780",
    description: "SPLY AND INSTLN OF GRAB BAR DIA:50MM,SS 510802300099",
    uom: "meter",
    rate: "2735.44",
  },
  {
    contract_line: "3790",
    tender_line: "3790",
    description: "FILLING MATERIAL WITH GSB THK:250MM 520401300003",
    uom: "square meter",
    rate: "443.86",
  },
  {
    contract_line: "3800",
    tender_line: "3800",
    description: "DISMANTLING - PAVER BLKREMOVING&STACKING 529050301174",
    uom: "square meter",
    rate: "69.68",
  },
  {
    contract_line: "3810",
    tender_line: "3810",
    description: "TPT-PAVER,LOAD,UNLOADING&STACKING 520950400002",
    uom: "Each",
    rate: "11641.09",
  },
  {
    contract_line: "3820",
    tender_line: "3820",
    description: "RELAY - PAVER BLKSREMOVED PAVER BLK & SA 520450300007",
    uom: "square meter",
    rate: "161.72",
  },
  {
    contract_line: "3830",
    tender_line: "3830",
    description: "SUP & INST - PANEL BOARDWALL MOUNTED,DEL 395050303905",
    uom: "Each",
    rate: "87749.00",
  },
  {
    contract_line: "3840",
    tender_line: "3840",
    description: "SPLY AND FIXG OF PIPE DIA:8IN,PVC 270102301404",
    uom: "meter",
    rate: "846.44",
  },
  {
    contract_line: "3850",
    tender_line: "3850",
    description: "SPLY AND LAYG OF GREY PAVER THK:80MM 510550300093",
    uom: "square meter",
    rate: "812.89",
  },
  {
    contract_line: "3860",
    tender_line: "3860",
    description: "SUPPLY,DLVRY&INSTLTN,PNL BRD,WL MNTD 381401300004",
    uom: "Each",
    rate: "65710.68",
  },
  {
    contract_line: "3870",
    tender_line: "3870",
    description: "SPLY AND FIXG OF LED LIGHT RAT:9W 391101300672",
    uom: "Each",
    rate: "201.29",
  },
  {
    contract_line: "3880",
    tender_line: "3880",
    description: "SPLY AND FIXG OF LED LIGHT RAT:10W 391101300671",
    uom: "Each",
    rate: "201.29",
  },
  {
    contract_line: "3890",
    tender_line: "3890",
    description: "SPLY AND FIXG OF STABILIZER RAT:5KVA,1PH 390301302187",
    uom: "Each",
    rate: "11475.07",
  },
  {
    contract_line: "3900",
    tender_line: "3900",
    description: "FIXING OF PV VENT 176050302198",
    uom: "Each",
    rate: "1663.63",
  },
  {
    contract_line: "3910",
    tender_line: "3910",
    description: "SUP & LAY - RCC DRIVEWAYRATIO:1:1.5:3,M2 510202300473",
    uom: "cubic meter",
    rate: "7174.07",
  },
  {
    contract_line: "3920",
    tender_line: "3920",
    description: "SUP & ERECT - LITING POLEYARD,MS,HGT:6MT 391101300670",
    uom: "Each",
    rate: "6736.23",
  },
  {
    contract_line: "3930",
    tender_line: "3930",
    description: "SPLY AND INSTLN OF 100MM PIPE HDPE 270102301405",
    uom: "meter",
    rate: "1776.31",
  },
  {
    contract_line: "3940",
    tender_line: "3940",
    description: "SPLY AND INSTLN OF 150MM PIPE HDPE 270102301406",
    uom: "meter",
    rate: "2062.76",
  },
  {
    contract_line: "3950",
    tender_line: "3950",
    description: "APPLY OF ENAMEL PAINTING 330150300574",
    uom: "meter",
    rate: "3.44",
  },
  {
    contract_line: "3960",
    tender_line: "3960",
    description: "SPLY AND PASTING OF VINYL SIZE:50MM 519050303956",
    uom: "meter",
    rate: "68.82",
  },
  {
    contract_line: "3970",
    tender_line: "3970",
    description: "SPLY&INSTLN OF FILL CAP W/LOCK 180101300347",
    uom: "Each",
    rate: "13370.09",
  },
  {
    contract_line: "3980",
    tender_line: "3980",
    description: "VRS COUPLER SIZE:4IN 268501300131",
    uom: "Each",
    rate: "5268.73",
  },
  {
    contract_line: "3990",
    tender_line: "3990",
    description: "S-FLEXIBLE PIPE SUPPLY-FLEXIBLE PIPE 176103300104",
    uom: "meter",
    rate: "1767.71",
  },
  {
    contract_line: "4000",
    tender_line: "4000",
    description: "I-FLEXIBLE PIPE 176103300105",
    uom: "meter",
    rate: "535.04",
  },
  {
    contract_line: "4010",
    tender_line: "4010",
    description: "SUP&INST - FLAME ARRESTORIN-LINE DETONAT 180101300346",
    uom: "Each",
    rate: "6860.10",
  },
  {
    contract_line: "4020",
    tender_line: "4020",
    description: "SPLY AND INSTLN OF DUST CAP AL,SIZE:4IN 180101300345",
    uom: "Each",
    rate: "2581.46",
  },
  {
    contract_line: "4030",
    tender_line: "4030",
    description: "SPLY & INSTLN OF VAPOR ADAPTER SIZE:4IN 180101300344",
    uom: "Each",
    rate: "6811.06",
  },
  {
    contract_line: "4040",
    tender_line: "4040",
    description: "SPLY&FIXG CANOPY LIGHT FIXTURE LED,80W 391101300669",
    uom: "Each",
    rate: "4971.96",
  },
  {
    contract_line: "4050",
    tender_line: "4050",
    description: "SUP & FIX - 80W LGT FIXTASYMMETRICLED YA 511806400001",
    uom: "Each",
    rate: "5146.58",
  },
  {
    contract_line: "4060",
    tender_line: "4060",
    description: "SPLY AND LAY OF PIPE80MM,CL C,IS 1239 511202300368",
    uom: "meter",
    rate: "1085.57",
  },
  {
    contract_line: "4070",
    tender_line: "4070",
    description: "SUP & LAY - PIPEHVY DTY ERWWELDED,50MM 511202300367",
    uom: "meter",
    rate: "15068.12",
  },
  {
    contract_line: "4080",
    tender_line: "4080",
    description: "SPLY&INSTLN ELECTRODE EARTHING PIPE 390850300053",
    uom: "Each",
    rate: "7225.68",
  },
  {
    contract_line: "4090",
    tender_line: "4090",
    description: "SPLY AND INSTLN OF POLE HGT:8MT 395003300639",
    uom: "Each",
    rate: "10094.45",
  },
  {
    contract_line: "4100",
    tender_line: "4100",
    description: "SPLY AND INSTLN OF POLE HGT:6MT 395003300640",
    uom: "Each",
    rate: "8651.03",
  },
  {
    contract_line: "4110",
    tender_line: "4110",
    description: "SPLY AND INSTLN OF POLE HGT:5MT 395003300638",
    uom: "Each",
    rate: "8171.90",
  },
  {
    contract_line: "4120",
    tender_line: "4120",
    description: "REFLECTIVE PAINT DEMARCATION 330150300575",
    uom: "square meter",
    rate: "1068.37",
  },
  {
    contract_line: "4130",
    tender_line: "4130",
    description: "ELECTRICAL INSULATION MAT-2.5MM THICK 390301400006",
    uom: "square meter",
    rate: "960.84",
  },
  {
    contract_line: "4140",
    tender_line: "4140",
    description: "SUPPLY & FIX FRP MH COV D400 519050400010",
    uom: "Each",
    rate: "39808.34",
  },
  {
    contract_line: "4150",
    tender_line: "4150",
    description: "SUPPLY & FIX FRP MH COV C250 519050400011",
    uom: "Each",
    rate: "13787.29",
  },
  {
    contract_line: "4160",
    tender_line: "4160",
    description: "PROVIDING LIFTING APPARATUS OF FRP COV 519050400012",
    uom: "Each",
    rate: "7596.43",
  },
  {
    contract_line: "4170",
    tender_line: "4170",
    description: "HYDRAULIC STEEL MH COVER 940MM X 940MM 519050400013",
    uom: "Each",
    rate: "11222.37",
  },
  {
    contract_line: "4180",
    tender_line: "4180",
    description: "SUPPLY AND FIXING OF 50 MM DI,49RU000333 173401300007",
    uom: "Each",
    rate: "3841.65",
  },
  {
    contract_line: "4190",
    tender_line: "4190",
    description: "SUPPLY,FIXING,TESTING AND COM,49RU000250 380102300622",
    uom: "Each",
    rate: "6549.56",
  },
  {
    contract_line: "4200",
    tender_line: "4200",
    description: "CORE CUTTING SLABS FOR 125MM 519050301127",
    uom: "Each",
    rate: "1376.32",
  },
];
